import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import styles from './MessageListheader.module.scss'
import { CustomCol, CustomTitle } from 'src/components'
import MessageListSelector from './MessageListSelector/MessageListSelector'
import MessageListFilterInput from './MessageListFilterInput/MessageListFilterInput'

const MessageListheader: React.FC<{ messagesLength: number }> = ({ messagesLength }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <Row>
    <CustomCol lg={12}>
      <CustomTitle
        label={t('general.ResultsLength', { length: messagesLength })}
        className={styles.title}
        type={null}
      />
    </CustomCol>
    <CustomCol
      lg={8} xs={18}
      className={isMobile && 'mt-2'}
    >
      <MessageListFilterInput />
    </CustomCol>
    <CustomCol
      lg={4} xs={5}
      className={isMobile && 'mt-2 ml-1'}
    >
      <MessageListSelector />
    </CustomCol>
  </Row>
}

export default MessageListheader
